import React from "react";
import {
  Linking,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
} from "react-native";
import Caret from "@assets/svg/Caret";
import Phone from "@assets/svg/Phone";
import WhatsApp from "@assets/svg/WhatsApp";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import { ORDER_TRACKING } from "@constants/analyticsEventsCT";
import color from "../../constants/color";

const DeliveryCard = (props) => {
  const {
    order_id = "",
    user_name = "",
    num_items = "",
    num_quantity = "",
    user_phone = "",
    payable_amount = "",
    payment_mode = "",
    onDeliver = () => {},
    onNotDeliver = () => {},
    navigateToDetails = () => {},
    item_ids = [],
    undelivered_to_cx_reason = null,
    undeliveredReasons = null,
  } = props;

  return (
    <View style={styles.card}>
      <View style={styles.orderPhoneWhatsapp}>
        <TouchableOpacity
          style={styles.orderCaret}
          onPress={() => {
            navigateToDetails(order_id);
          }}
        >
          <Text style={styles.orderNumber}>आर्डर नंबर - {order_id}</Text>
          <Caret strokeColor={color.primary} />
        </TouchableOpacity>
        <View style={styles.phoneWhatsapp}>
          <TouchableOpacity
            style={styles.touchable}
            onPress={() => {
              handleCallButtonPress(
                user_phone,
                ORDER_TRACKING.DELIVERY_CARD_CALL,
                {
                  order_id,
                },
              );
            }}
          >
            <Phone />
          </TouchableOpacity>

          <View style={styles.spacer} />
          <View style={styles.spacer} />

          <TouchableOpacity
            style={styles.touchable}
            onPress={() => {
              Linking.openURL(`whatsapp://send?phone=+91${user_phone}`);
            }}
          >
            <WhatsApp />
          </TouchableOpacity>
        </View>
      </View>
      <View style={styles.nameItemsPrice}>
        <View>
          <Text style={styles.name}>{user_name}</Text>
          <Text style={styles.lightBlack}>
            {num_items} आइटम्स • {num_quantity} मात्रा{" "}
          </Text>
        </View>
        <Text style={styles.lightBlack}>
          {payment_mode}
          <Text style={styles.blackBold}> ₹{payable_amount}</Text>
        </Text>
      </View>
      <View style={styles.buttons}>
        <TouchableOpacity
          style={styles.button}
          onPress={() => {
            onNotDeliver(
              {
                item_ids,
              },
              {
                order_id,
              },
            );
          }}
        >
          <Text style={styles.buttonText}>डिलीवर नहीं हुआ</Text>
        </TouchableOpacity>

        <View style={styles.spacer} />

        <TouchableOpacity
          style={styles.button}
          onPress={() => {
            onDeliver(
              {
                item_ids,
              },
              user_name,
              order_id,
            );
          }}
        >
          <Text style={styles.buttonText}>डिलीवर्ड</Text>
        </TouchableOpacity>
      </View>
      {undelivered_to_cx_reason &&
      Array.isArray(undeliveredReasons) &&
      undeliveredReasons.length ? (
        <Text
          style={styles.undeliveredReason}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {undeliveredReasons.find((r) => r.value === undelivered_to_cx_reason)
            ?.label || ""}
        </Text>
      ) : (
        <></>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  orderPhoneWhatsapp: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  orderCaret: {
    flexDirection: "row",
    alignItems: "center",
  },
  phoneWhatsapp: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  card: {
    backgroundColor: "white",
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0,0,0,0.1)",
  },
  orderNumber: {
    fontSize: 14,
    lineHeight: 20,
    color: "rgba(0,0,0,0.87)",
  },
  nameItemsPrice: {
    flexDirection: "row",
    alignItems: "flex-end",
    marginVertical: 10,
    justifyContent: "space-between",
  },
  name: {
    fontWeight: "bold",
    fontSize: 16,
    lineHeight: 24,
  },
  buttons: {
    marginVertical: 10,
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "space-between",
  },
  button: {
    flex: 1,
    borderWidth: 1,
    borderColor: "black",
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 6,
  },
  buttonText: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: 24,
    alignSelf: "center",
    // backgroundColor: "blue",
    textAlignVertical: "center",
    flex: 1,
  },
  spacer: {
    width: 15,
  },
  lightBlack: {
    color: color.lightBlack,
  },
  blackBold: {
    color: "black",
    fontWeight: "bold",
  },
  touchable: {
    padding: 2,
  },
  undeliveredReason: {
    fontWeight: "bold",
    color: color.primary,
    opacity: 0.75,
    fontSize: 14,
  },
});
export default DeliveryCard;
